import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * for this page
 */

// 数据条
class Bar extends React.PureComponent {
    static propTypes = {
        index: PropTypes.number,
        nump: PropTypes.number,
    };

    state = {
        percent: 0,
    };

    componentDidMount = () => {
        this.increase(this.props.nump);
    };

    // 长度渐变动画
    increase = targetPercent => {
        const percent = 0;
        const speed = (targetPercent - percent) / 400;
        let start = null;
        const animate = timestamp => {
            if (!start) start = timestamp;
            const progress = timestamp - start;
            const currentProgress = Math.min(parseInt(speed * progress + percent, 10), targetPercent);

            // console.log(currentProgress);
            this.setState({
                percent: currentProgress,
            });
            if (currentProgress < targetPercent) {
                window.requestAnimationFrame(animate);
            }
        };

        window.requestAnimationFrame(animate);
    };

    render() {
        const { index } = this.props;
        const { percent } = this.state;

        return (
            <em
                // 根据索引渲染不同的背景色
                className={`${styles.bar} ${styles[`sgn${index + 1 <= 10 ? index + 1 : (index + 1) % 10}`]}`}
                style={{ width: `${percent}%` }}
            />
        );
    }
}

export default Bar;
